module.exports = __webpack_public_path__ + "files/c34065e5094ae7b193abf2cdcdb0b83f.png";